import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {QuestionExecution} from '../../../data/models/execution/question-execution';

@Component({
  selector: 'app-question-execution-numbers',
  templateUrl: './question-execution-numbers.component.html',
  styleUrls: ['./question-execution-numbers.component.css']
})
export class QuestionExecutionNumbersComponent implements OnInit {

  @Input() questions!: QuestionExecution[];
  @Input() currentQuestionId!: number;

  @Output() selectQuestion = new EventEmitter<number>();

  constructor() {
  }

  ngOnInit(): void {
  }

  onQuestionSelect(questionId: number): void {
    this.selectQuestion.emit(questionId);
  }

}
